/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import { useIntl } from 'react-intl'
import { PLAYER_TYPE_COMPUTER } from '../actions/game'
import { LEVELS, log } from '../logs'

const Summary = props => {
  log('Summary', LEVELS.INFO, props)
  const { players, cardCount, matchCount } = props
  const intl = useIntl()
  return (
    <div className='game-summary'>
      <p>{intl.formatMessage({ id: 'title.gameType' }, { cardCount, matchCount })}</p>
      <p>{intl.formatMessage({ id: 'title.player' }, { count: players })}:
        {
      players.reduce((acc, { name, type, level }, index) => {
        if (index > 0) {
          acc.push(` ${intl.formatMessage({ id: 'scores.vs' })} `)
        }
        acc.push(name)
        if (type === PLAYER_TYPE_COMPUTER) {
          acc.push(` (${intl.formatMessage({ id: 'title.playerLevel' }, { level })})`)
        }
        return acc
      }, [' ']).join('')
    }
      </p>
    </div>
  )
}

Summary.displayName = 'Summary'

export default Summary
